import { apiGet } from './api.js';
import { setState, getState } from './store.js';

const CACHE_KEY = (locale) => `lardr.i18n.cache.${locale}`;

export const SUPPORTED_LOCALES = ['en', 'de'];

const NATIVE_NAMES = {
  en: 'English',
  de: 'Deutsch',
};

export function localeNativeName(loc) {
  return NATIVE_NAMES[loc] || loc.toUpperCase();
}

export function currentLocale() {
  return getState().locale;
}

export async function loadLocale(locale) {
  // Try cache first
  const cachedRaw = localStorage.getItem(CACHE_KEY(locale));
  let cached = null;
  if (cachedRaw) {
    try { cached = JSON.parse(cachedRaw); } catch { cached = null; }
  }

  // Always fetch the latest (server is local; for Phase 1 just refetch when network is available)
  let bundle = cached;
  try {
    bundle = await apiGet(`/i18n/${locale}`);
    localStorage.setItem(CACHE_KEY(locale), JSON.stringify(bundle));
  } catch (e) {
    if (!bundle) throw e;  // no cache and network failed — bubble up
  }

  setState({ locale, t: bundle });
  return bundle;
}

export function t(key, params = {}) {
  const dict = getState().t || {};
  let val = dict[key] || key;
  for (const [k, v] of Object.entries(params)) {
    // Function replacement so `$`-patterns ($&, $', $`) in values (e.g. a
    // recipe named "Fish $& Chips") are inserted literally, not expanded.
    val = val.replace(`{${k}}`, () => String(v));
  }
  return val;
}
